import React, { memo, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import { injectIntl, FormattedMessage } from 'react-intl';

import messages from 'aurora-translations';
import BuyerSummary from './Summary';
import styles from './styles';

function BuyerList(props) {
  const { classes, data, locale, history, intl, buyerSelected, isExpired, nationalities, ...otherProps } = props;
  const [expandedId, setExpandedId] = useState(null);

  const buyersList = useMemo(() => {
    return data?.map((prop, index) => ({
      id: index + 1,
      ...prop,
      email: prop?.email,
      img: prop?.userDetails?.imageUrl,
      mobileNumber: prop?.mobileNumber,
      nameAR: prop?.userDetails?.customerNameA,
      nameEN: prop?.userDetails?.customerNameE,
      passportNumber: prop?.userDetails?.passportNumber,
      nationality:
        prop?.userDetails?.nationalityId &&
        nationalities.filter(national => national.value === prop?.userDetails?.nationalityId)[0]?.label,
      userId: prop?.userDetails?.userId,
    }));
  }, [data]);

  return (
    <>
      <div className={classes.titleHead}>
        <Typography variant='h1'>
          <FormattedMessage {...messages.buyer_list} />
        </Typography>
        <Typography
          variant='body1'
          classes={{
            root: classes.textGray,
          }}
        >
          <FormattedMessage {...messages.results} values={{ s: `${data?.length}` }} />
        </Typography>
      </div>
      <List className={classes.buyersList}>
        {buyersList?.map(item => (
          <BuyerSummary
            key={item.id}
            locale={locale}
            property={item}
            expandedId={expandedId}
            setExpandedId={setExpandedId}
            isExpired={isExpired}
            buyerSelected={buyerSelected}
            {...otherProps}
          />
        ))}
      </List>
    </>
  );
}

BuyerList.propTypes = {
  classes: PropTypes.object.isRequired,
  buyerSelected: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  history: PropTypes.object,
  nationalities: PropTypes.array,
  intl: PropTypes.object.isRequired,
  isExpired: PropTypes.bool.isRequired,
};
BuyerList.defaultProps = {
  history: {},
  nationalities: [],
};

export default withStyles(styles)(injectIntl(memo(BuyerList)));
